'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var closeFilled = require('./close-filled-e2468f78.js');
var clearRounded = require('./clear-rounded-defbdf4b.js');
var formField = require('./form-field-8601b6d9.js');
require('./enums-de2d9d36.js');
require('./messages-f8f39369.js');
var useBooleanState_hook = require('./use-boolean-state.hook-8d04931f.js');
var useOnClickOutside_hook = require('./use-on-click-outside.hook-fa9c21ca.js');

var activeStyles = {
    true: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.shadows.depth_2_primary;
    }),
    false: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    box-shadow: none;\n  "], ["\n    box-shadow: none;\n  "]))),
};
var iconLeftStyles = {
    sm: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    left: 8px;\n  "], ["\n    left: 8px;\n  "]))),
    md: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    left: 20px;\n  "], ["\n    left: 20px;\n  "]))),
    lg: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    left: 20px;\n  "], ["\n    left: 20px;\n  "]))),
};
var Icon = styled__default.span(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  margin-top: -12px;\n\n  .version-2 & {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  margin-top: -12px;\n\n  .version-2 & {\n    color: ",
    ";\n  }\n"])), function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return (isActive ? theme.colors.primary : theme.colors.greys.adminGreyDark);
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return (isActive ? theme.colors.palette.modifiedMalibuBlue
        : theme.colors.palette.systemGreyDark);
});
var StyledMenuItem = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 22px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  ", "\n  .field.search {\n    ", "\n    ", "\n    ", "\n  }\n\n  .clear {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  .icon {\n    ", "\n  }\n\n  .clear {\n    right: 20px;\n    margin-right: 0;\n    margin-left: 0;\n    border-width: 0;\n    height: 22px;\n    padding: 0;\n    background-color: transparent;\n    cursor: pointer;\n    outline: none;\n  }\n\n  .clear-filled {\n    right: 4px;\n    height: 24px;\n  }\n"], ["\n  position: relative;\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 22px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  ", "\n  .field.search {\n    ", "\n    ", "\n    ", "\n  }\n\n  .clear {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  .icon {\n    ", "\n  }\n\n  .clear {\n    right: 20px;\n    margin-right: 0;\n    margin-left: 0;\n    border-width: 0;\n    height: 22px;\n    padding: 0;\n    background-color: transparent;\n    cursor: pointer;\n    outline: none;\n  }\n\n  .clear-filled {\n    right: 4px;\n    height: 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var active = _a.active;
    return activeStyles[active];
}, function (_a) {
    var hasIcon = _a.hasIcon;
    return hasIcon && 'padding-left: 50px;';
}, function (_a) {
    var hasIcon = _a.hasIcon, size = _a.size;
    return hasIcon && size === 'sm' && 'padding-left: 40px;';
}, function (_a) {
    var hasClearButton = _a.hasClearButton;
    return hasClearButton && 'padding-right: 28px;';
}, function (_a) {
    var size = _a.size;
    return iconLeftStyles[size];
});
var SearchInput = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? 'Search…' : _b, _c = _a.id, id = _c === void 0 ? 'search-id' : _c, value = _a.value, setValue = _a.setValue, hasIcon = _a.hasIcon, hasClearButton = _a.hasClearButton, _d = _a.size, size = _d === void 0 ? 'lg' : _d, restProps = tslib_es6.__rest(_a, ["placeholder", "id", "value", "setValue", "hasIcon", "hasClearButton", "size"]);
    var onChange = React.useCallback(function (event) {
        setValue(event.target.value);
    }, [setValue]);
    var stopImmediatePropagation = React.useCallback(function (event) {
        event.stopPropagation();
        event.preventDefault();
    }, []);
    var onKeyDown = React.useCallback(function (event) {
        event.stopPropagation();
    }, []);
    var onKeyUp = React.useCallback(function (event) {
        if (event.keyCode === constants.SPACE_KEY) {
            event.preventDefault();
        }
    }, []);
    var _e = useBooleanState_hook.useBooleanState(), isActive = _e.value, toggleActive = _e.toggle, setFalse = _e.setFalse, setTrue = _e.setTrue;
    var clear = React.useCallback(function () { setValue(''); toggleActive(); }, [setValue, toggleActive]);
    var ref = React.useRef(null);
    useOnClickOutside_hook.useOnClickOutside(function () { return setFalse(); }, [ref]);
    React.useEffect(function () {
        if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
            setTrue();
        }
        else {
            setFalse();
        }
    }, [setFalse, setTrue, value === null || value === void 0 ? void 0 : value.length]);
    return (React__default.createElement(StyledMenuItem, { role: "search", className: "search-input-container", onClick: stopImmediatePropagation, onKeyDown: onKeyDown, onKeyUp: onKeyUp, hasIcon: hasIcon, hasClearButton: hasClearButton, size: size, active: isActive.toString(), ref: ref },
        hasIcon && React__default.createElement(Icon, { className: "icon material-symbols-outlined", isActive: isActive, "data-testid": "zoom" }, "search"),
        React__default.createElement(formField.FormField, tslib_es6.__assign({ id: id, placeholder: placeholder, variant: "search", fieldType: formField.FormFieldType.INPUT, onChange: onChange, value: value, searchSize: size, onClick: toggleActive }, restProps)),
        hasClearButton && isActive && size === 'sm' && (React__default.createElement(closeFilled.CloseFilled, { size: "lg", className: "clear clear-filled", onClick: clear, "data-testid": "clear", variant: "adminGreyDark" })),
        hasClearButton && size !== 'sm' && (React__default.createElement("button", { type: "button", "aria-label": "Clear", className: "clear", onClick: clear, "data-testid": "clear" },
            React__default.createElement(clearRounded.ClearRounded, { size: "lg", variant: "adminGreyDark" })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

exports.SearchInput = SearchInput;
